var map = {
	"./arrow.svg": "1106",
	"./back.svg": "a11e",
	"./calendar.svg": "4fef",
	"./cancel.svg": "fd77",
	"./check.svg": "6aa8",
	"./close.svg": "1d1b",
	"./documents.svg": "43ad",
	"./fire.svg": "cbb5",
	"./gantel.svg": "a544",
	"./gift.svg": "2e5e",
	"./kek.svg": "a2a9",
	"./key.svg": "08bd",
	"./lightning.svg": "8cfa",
	"./location.svg": "e496",
	"./logout.svg": "0627",
	"./money.svg": "7530",
	"./sad.svg": "0a12",
	"./star.svg": "d8e7",
	"./tick_circle.svg": "84fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";